<template>
  <div class="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
    <article
      v-for="highlight in highlights"
      :key="highlight.title"
      class="flex flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition hover:border-brand-200 hover:shadow-md"
    >
      <span
        class="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-50 text-brand-600 ring-1 ring-inset ring-brand-100"
      >
        <svg
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            v-for="(d, index) in highlight.icon"
            :key="index"
            stroke-linecap="round"
            stroke-linejoin="round"
            :d="d"
          />
        </svg>
      </span>
      <h3 class="mt-5 text-base font-semibold text-ink">
        {{ highlight.title }}
      </h3>
      <p class="mt-2 text-sm leading-relaxed text-slate-600">
        {{ highlight.body }}
      </p>
    </article>
  </div>
</template>

<script>
export default {
  name: "Pakkumine",
  data() {
    return {
      highlights: [
        {
          title: "Veo- ja sõiduautorehvide eksperdid",
          body: "Üle 30 aasta kogemust rasketehnikast sõiduautodeni aitab meil soovitada täpselt sinu liiklusvajadustele sobivaid lahendusi.",
          icon: [
            "M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12",
          ],
        },
        {
          title: "Taastamine ja remont",
          body: "Koostöös tunnustatud partneritega taastame rehve ning korrastame velgi, et pikendada nende eluiga ja hoida kulud kontrolli all.",
          icon: [
            "M21.75 6.75a4.5 4.5 0 0 1-4.884 4.484c-1.076-.091-2.264.071-2.95.904l-7.152 8.684a2.548 2.548 0 1 1-3.586-3.586l8.684-7.152c.833-.686.995-1.874.904-2.95a4.5 4.5 0 0 1 6.336-4.486l-3.276 3.276a3.004 3.004 0 0 0 2.25 2.25l3.276-3.276c.256.565.398 1.192.398 1.852Z",
            "M4.867 19.125h.008v.008h-.008v-.008Z",
          ],
        },
        {
          title: "Kiired hooajavahetused",
          body: "Planeerime tööd paindlikult ning tagame, et hooajavahetus ja rehvide vahetus oleksid tehtud esimesel võimalusel.",
          icon: ["M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"],
        },
        {
          title: "Nõustamine ja järelteenindus",
          body: "Selgitame välja sinu sõidustiili ning soovitame hooldust, mis hoiab rehvid kvaliteetsena ka pärast töökotta külaskäiku.",
          icon: [
            "M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 0 1 1.037-.443 48.282 48.282 0 0 0 5.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z",
          ],
        },
      ],
    };
  },
};
</script>
